import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <div className='row'>
    <label className='reconcile-label col-lg-4'>{props.label}</label>
    <div className='col-lg-7'>
      <select
        className='form-control'
        name={props.name}
        ref={ref}
        onChange={props.onChange}
      >
        { props.options.map((option, i) => {
          return <option key={i} value={option}>{option}</option>
        })}
      </select>
      {props.error && <div className='error_container'>{props.error.message}</div>}
    </div>
  </div>
))

export default SelectInput
